export default __webpack_public_path__ + "static/dotnet-8d44c4880939507d12d9f4152e224a27.svg";